import { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { ArrayUnitValue, Media } from '../../types';
import { exceptStyledProps, setDeclaration } from '../../utils';
import { Colors } from '../Colors';

export interface Props extends HTMLAttributes<HTMLDivElement> {
  margin?: ArrayUnitValue | Media<ArrayUnitValue>;
}

export const Separator = styled('div', exceptStyledProps('color'))<Props>`
  ${props => setDeclaration('margin', props.margin || [10, 0], 'rem')};
  height: 0;
  border-bottom: 1px solid ${props => props.color || Colors.ut.border10};
`;
